import React, { useEffect, useState } from 'react';
import useAlertNotification from '../../../../context/AlertNotificationContext';
import { FaHistory, FaPen, FaSave, FaSpinner, FaTrash } from 'react-icons/fa';
import { MdClose, MdOutlineArrowBack } from 'react-icons/md';
import { Prompt, useHistory, useLocation, useRouteMatch } from 'react-router-dom'; 
import { FormBuilder, FormStateBuilder } from '../../../../components/FormBuilder';
import ErrorRequestService from '../../../../services/errorRequest';
import PageContainer from '../../../../components/PageContainer';
import Loading from '../../../../components/Loading';
import CargaHorariaValidation from '../../../../services/validation/CargaHorariaValidation';
import CargaHorariaApiService from '../../../../services/api/CargaHorariaApiService';
import CargaHorariaViewInfo from './CargaHorariaViewInfo';

const CargaHorariaView = ({ editable = false }) => {
    // CONTEXT
    const match = useRouteMatch();
    const location = useLocation();
    const history = useHistory();
    const alert = useAlertNotification();

    //PROPS
    const { cod } = match.params;

    // STATES
    const [originalData, setOrginalData] = useState(null);
    const [formFields, setFormFields] = useState({});
    const [formData, setFormData] = useState({});
    const [edit, setEdit] = useState(editable);
    const [isEdited, setIsEdited] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    // FUNCTIONS
    const isFormEdited = () => {
        const jsonOrigData = JSON.stringify(originalData);
        const jsonFormData = JSON.stringify(formData);
        return (edit) && (jsonOrigData !== jsonFormData);
    }

    const askForLeave = (cbPositive, cbNegative=()=>{}) => {
        if (cbPositive instanceof Function) {
            const msg = 'Foram feitas alterações!\nDeseja realmente sair e perdê-las?';
            const leave = window.confirm(msg);

            if (leave) cbPositive();
            else cbNegative();
        }
        return false;
    }

    const handleCancel = () => {
        if (isEdited) {
            askForLeave(() => {
                setIsEdited(false);
                setFormData(originalData);
                setEdit(!edit);
            });
            return;
        }

        if (edit) {
            setEdit(!edit);
            return;
        }

        history.goBack();
    }

    const saveForm = async () => {
        try {

            const validation = await CargaHorariaValidation.validate(formData);
            if (!validation.isValid) {
                alert.error("Erros no formulário!");
                return;
            }
            
            // se ok, enviar p/ API
            const resp = await CargaHorariaApiService.updateOne(formData.cod, formData);
            if (resp) {
                setIsEdited(false);
                setEdit(false);
                alert.success("Dados da carga horaria atualizados!");
                const url = `${match.url.replace(`/${formData.cod}`, '')}`;
                history.replace(url, location.state);
            }
        }
        catch (err) {
            const errorService = new ErrorRequestService(err);
            const errorMsg = errorService.getErrors();
            console.log(errorMsg);
            alert.error(errorMsg);
        }
    }
    
    const toggleEdit = () => {
        if (isEdited) {
            askForLeave(() => {
                setFormData(originalData);
                setEdit(!edit);
            });
            return;
        }
        setEdit(!edit);
    }

    const onChange = (ev) => {
        const { value, name } = ev.target;
        const newform = {...formData, [name]: value};
        setFormData(newform);
    }

    const onEdit = () => {
        if (isFormEdited() && !isEdited) setIsEdited(true);
    }

    const onStart = () => {
        const getData = async () => {
            try {
                setIsLoading(true);
                const formFields = await CargaHorariaViewInfo.getFormFields();
                const formData = await CargaHorariaApiService.getOneByCod(cod);
                setFormFields( formFields );
                setFormData( formData.data[0] );
                setOrginalData( formData.data[0] );
            }
            catch (err) {
                const errorService = new ErrorRequestService(err);
                const errorMsg = errorService.getErrors();
                console.log(errorMsg);
                alert.error(errorMsg);
            }
            finally {
                setIsLoading(false);
            }
        }
        getData();
    }

    useEffect(onStart, []);
    useEffect(onEdit, [formData]);

    const actions = [
        ...( !edit ? [
            {
                label: 'Editar',
                icon: <FaPen />,
                color: 'primary',
                type: 'button',
                onClick: toggleEdit,
            }
        ]:[
            {
                label:'Salvar',
                icon: <FaSave />,
                color: 'success',
                type: 'button',
                onClick: saveForm
            }
        ]),
        (!edit ? 
        {
            label: 'Voltar',
            icon: <MdOutlineArrowBack />,
            color: 'info',
            type: 'button',
            onClick: () => history.push( match.path.replace('/:cod','') )
        } : {
            label: 'Cancelar',
            icon: <MdClose /> ,
            color: 'secondary',
            type: 'button',
            onClick: handleCancel
        })
    ]
    
    return(
        <PageContainer
            title={"Carga Horária"}
            actions={actions}
        >
            { isLoading
                ? <Loading message="Carregando..." />
                : ( originalData &&
                    <FormBuilder
                        formFields={formFields}
                        formData={formData}
                        onChange={onChange}
                        disabledForm={!edit}
                        initialValues={originalData}
                        schema={CargaHorariaValidation.schema}
                    />
                )
            }

            <Prompt
                when={isEdited}
                message={location => askForLeave(() => {
                    setIsEdited(false);
                    setTimeout(() => {
                        history.push(location.pathname);
                    }, 100);
                })}
            />
        </PageContainer>
    )
};

export default CargaHorariaView;